/* eslint-disable react/no-array-index-key */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';

const TYPE_MAP = {
  main: { id: 'AI 대화', color: '#3b82f6' },
  read: { id: '언어훈련', color: '#10b981' },
  write: { id: '언어훈련', color: '#10b981' },
  listen: { id: '언어훈련', color: '#10b981' },
  exercise: { id: '신체훈련', color: '#f59e0b' },
  flag: { id: '신체훈련', color: '#f59e0b' },
  head: { id: '신체훈련', color: '#f59e0b' },
  grab: { id: '신체훈련', color: '#f59e0b' },
  draw: { id: 'AI훈련', color: '#ec4899' },
  mirror: { id: 'AI훈련', color: '#ec4899' },
  voice: { id: 'AI훈련', color: '#ec4899' },
  color: { id: '인지훈련', color: '#ef4444' },
  number: { id: '인지훈련', color: '#ef4444' },
  piano: { id: '인지훈련', color: '#ef4444' },
};

const RADIAN = Math.PI / 180;
const renderLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {
  if (cx == null || cy == null) return null;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
    >
      {`${((percent ?? 1) * 100).toFixed(0)}%`}
    </text>
  );
};

const PiCarePieChartUsage = () => {
  const { interactionCount, loading } = useSelector(
    (state) => state.picareDashboard,
  );

  const pieData = useMemo(() => {
    if (!interactionCount?.length) return [];
    const grouped = interactionCount.reduce((acc, item) => {
      const mapping = TYPE_MAP[item.type];
      if (!mapping) return acc;
      const { id, color } = mapping;
      const current = acc[id];
      return {
        ...acc,
        [id]: current
          ? { id, fill: color, count: current.count + item.count }
          : { id, fill: color, count: item.count },
      };
    }, {});
    return Object.values(grouped);
  }, [interactionCount]);

  if (loading.interactionCount) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Tooltip formatter={(value, name) => [value, name]} />
        <Legend
          align="right"
          layout="vertical"
          iconType="square"
          iconSize={10}
          formatter={(value) => (
            <span style={{ color: '#64748b', fontSize: 12 }}>{value}</span>
          )}
        />
        <Pie data={pieData} dataKey="count" nameKey="id" outerRadius="80%" label={renderLabel}>
          {pieData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.fill} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default PiCarePieChartUsage;
